import {
    ATTR_CREATED_MS_I,
    ATTR_LAST_ARCHIVED_MS,
    ATTR_OBJ_STATE,
    ATTR_PRJ_DESC, ATTR_PROJECT_START, ATTR_UPDATED_MS_I,
    getActiveProject,
    getLogoThumpPath, getValidInteger,
    hasPermissionTo,
    isValueEmpty, OBJ_STATE_ACT,
    QUERY_STATUS_SUBPROJECT,
    startLongQuery, stopLongQuery, STR_NO_VALUE,
    getUserRole,
    getRoleForUi
} from "../prodect/ProsConnect";
import {renderCard} from "./Dashboard";
import {addAText} from "../components/Common";
import UiImage from "../components/UiImage";
import {formatDate, getObjectStateText} from "../prodect/ProsCommonUi";
import React, {useEffect, useState} from "react";
import BasicButton from "../components/BasicButton";
import LoadingAnimation from "../components/LoadingAnimation";

export default function DashboardSubprojectInfo(props){
    const showingMeters = props.meterCount >= 2
    const [projectStatus, setProjectStatus] = useState(undefined)

    const subprj = getActiveProject()
    const UNIQUE_UI_ID = "dash-sproj-status"

    function isFresh() {
        return projectStatus && projectStatus.isFresh
    }

    useEffect(() => {
        startLongQuery(UNIQUE_UI_ID, QUERY_STATUS_SUBPROJECT, props.projectId,
            (response, isFresh, lastUpdated) => {
                let newData = response
                newData.isFresh = isFresh
                newData.lastUpdated = lastUpdated
                setProjectStatus(newData)
        })

        return () => {
            stopLongQuery(UNIQUE_UI_ID)
        }
    }, [props])

    const obsCount = projectStatus?.total_counts?.obs
    const itemCount = projectStatus?.total_counts?.items
    const picCount = projectStatus?.total_counts?.picts ?? 0
    const vidCount = projectStatus?.total_counts?.video ?? 0
    const attachmentCount = picCount + vidCount
    const activeUserCount = projectStatus?.total_counts?.active_users
    const userCount = projectStatus?.user_count
    const uiBoxes = [
        {
            text: addAText(obsCount, 'kirjaus', 'ta'),
            img: "check-list"
        },
        {
            text: addAText(itemCount,' tieto','a'),
            img: "project"
        },
        {
            text: addAText(attachmentCount,'liitettä', ''),
            detail: vidCount > 0
                ? picCount + ' kuvaa, '
                    + vidCount + ' videota' : null,
            img: "pack"
        },
        {
            text: addAText(userCount,'käyttäjä','ä'),
            detail:  activeUserCount + ' aktiivista',
            img: "user"
        }
    ]

    function renderLogo(){
        if(isValueEmpty(subprj.attrs.logo)) return null
        return <UiImage
            imageSrc={getLogoThumpPath(subprj.attrs.logo)}
            alt={"Osaprojektin logo"}
        />
    }

    function renderProjectStarted() {
        let projectCreated = getValidInteger(subprj.attrs[ATTR_CREATED_MS_I], 0, 0)
        let projectStarted = getValidInteger(subprj.attrs[ATTR_PROJECT_START], 0, 0)
        return projectStarted > 0 ?
            "aloitettu " + formatDate(projectStarted) :
            "luotu " + formatDate(projectCreated)
        // subprj.attrs[ATTR_OBJ_STATE]
    }

    function renderProjectState() {
        let stateText = getObjectStateText(subprj.attrs[ATTR_OBJ_STATE], true)
        if (subprj.attrs[ATTR_OBJ_STATE] !== OBJ_STATE_ACT) {
            // Archived - not billed, use "updated" if does not have an explicit time when archived
            let whenArchived = getValidInteger(subprj.attrs[ATTR_LAST_ARCHIVED_MS], subprj.attrs[ATTR_UPDATED_MS_I])
            return stateText + " " + formatDate(whenArchived)
        }
        // active
        return stateText
    }

    function renderSubProjectUsageInfo(){
        let reasonNotShowing =
            !projectStatus ? <div className={"card"}>
                <LoadingAnimation text={"Ladataan"} color={"var(--color-light)"} />
            </div> : null
            ||
            !isFresh()? <div className={"card"}>
                <LoadingAnimation text={"Päivitetään"} color={"var(--color-light)"} />
            </div> : null
        let projStatBoxes = isFresh() ?
            <div className={"grid-container grid-2"}>
                {uiBoxes.map((item, i)=> renderCard(item, i))}
            </div> : null
        return <>
            {reasonNotShowing}
            {projStatBoxes}
        </>
    }

    function renderCommonSettingsButton(){
        return <BasicButton
            btnClass={"primary"}
            label={"Järjestele"}
            icon={"reorder"}
            action={()=> props.openCommonSettings()}
            shrink={"md"}
        />
    }

    function renderAddChartButton(btnClass = null){
        if (!hasPermissionTo('editDashboard')) {
            return null
        }
        return <BasicButton
            btnClass={btnClass}
            label={"Lisää kuvaaja"}
            icon={"plus"}
            action={()=> props.openAddChart()}
            shrink={"md"}
            hilite={!btnClass}
        />
    }

    function renderDashNavigation(){
        if(!hasPermissionTo('editDashboard')) {
            return null
        }
        return <div className={"grid-container grid-2 margin-top"}>
            {showingMeters ? renderCommonSettingsButton() : null}
            {renderAddChartButton("primary")}
        </div>
    }

    function renderChangeAmount(){
        if (!isFresh()) {
            return null
        }
        return <p>Muutoksia tässä kuussa {projectStatus.monthly_curr.changes},
            edellinen kuukausi {projectStatus.monthly_prev.changes} </p>
    }

    function renderTextBox(){
        let lastChanged = isFresh() && projectStatus.last_updated_by !== STR_NO_VALUE ? <p>Viimeisin muutos
                <strong> {projectStatus.last_updated_by} </strong>
                {formatDate(projectStatus.last_updated, true)}
            </p>
            : null
        return <>
            {subprj.attrs[ATTR_PRJ_DESC] ? <p>{subprj.attrs[ATTR_PRJ_DESC]}</p> : ""}
            <p>Osaprojekti on {renderProjectStarted()} ja se on <strong>{renderProjectState()}</strong></p>
            {renderChangeAmount()}
            {lastChanged}
        </>
    }
    
    function renderTextBoxUser(){
        return <p>Käyttöoikeutesi: <strong>{getRoleForUi(getUserRole())}</strong></p>
    }

    return <div id="dashboard-info" className="block size-1 display-flex-v">
        {renderLogo()}
        <div className="display-flex-v flex-grow">
            {renderSubProjectUsageInfo()}
            <div className="card margin-top text-box flex-grow">
                {renderTextBox()}
            </div>
            <div className="card margin-top text-box">
                {renderTextBoxUser()}
                {renderDashNavigation()}
            </div>
            
        </div>
    </div>
}

